import { Directive } from '@angular/core';

@Directive({
  selector: '[qpointGridDetailTemplate]',
  standalone: true
})
export class QPointGridDetailTemplateDirective { }
